// extracted by mini-css-extract-plugin
export default {"host":"PageTitleContainer_host__Sh8C+","TitleText":"PageTitleContainer_TitleText__MIcFJ"};